// extracted by mini-css-extract-plugin
export default {"root":"LogoHeadSettings_root__2o+1g","logo":"LogoHeadSettings_logo__hX8Ex"};